import React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {}

const EKGLineSVG: React.FC<Props> = props => {
  return (
    <svg
      width={1106}
      height={118}
      viewBox="0 0 1106 118"
      overflow="visible"
      {...props}
    >
      <defs>
        <linearGradient id="fadeGrad" y2="0" x2="1">
          <stop offset="0" stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" stopOpacity=".75" />
        </linearGradient>
        <mask id="gradient-mask" maskContentUnits="objectBoundingBox">
          <rect width="1" height="1" fill="url(#fadeGrad)" />
        </mask>
      </defs>
      <path
        mask="url(#gradient-mask)"
        d="M308.853 1935h29.144a1 1 0 00.747-.334l8.165-9.152a1 1 0 011.481-.012l8.452 9.176a1 1 0 00.736.322h12.895a1 1 0 00.999-.963l2.681-71.794a1 1 0 011.998-.012l4.258 87.514a1 1 0 001.985.117l2.356-14.028a1 1 0 01.986-.834h20.338a1 1 0 00.827-.44l11.17-16.485a1 1 0 011.581-.097l14.547 16.68a1 1 0 00.754.342h61.4a1 1 0 00.75-.338l8.093-9.17a1 1 0 011.46-.043l9.184 9.255a1 1 0 00.71.296h6.424a1 1 0 00.999-.951l3.666-75.059a1 1 0 011.997-.002l4.71 92.194a1 1 0 001.979.15l3.198-15.534a1 1 0 01.98-.798h15.208a1 1 0 00.698-.284l14.734-14.36a1 1 0 011.443.049l12.75 14.261a1 1 0 00.745.334h64.372a1 1 0 00.744-.332l8.277-9.216a1 1 0 011.429-.06l9.934 9.337a1 1 0 00.685.271h6.711a1 1 0 00.996-.908l7.505-80.923a1 1 0 011.995.044l4.623 96.56a1 1 0 001.985.118l2.381-14.058a1 1 0 01.986-.833h10.18a1 1 0 00.701-.287l17.347-17.048a1 1 0 011.376-.024l18.65 17.096a1 1 0 00.675.263h59.207a1 1 0 00.782-.376l7.174-8.995a1 1 0 011.536-.033l7.881 9.06a1 1 0 00.755.344h8.58a1 1 0 00.996-.906l7.715-81.435a1 1 0 011.994.044l5.139 100.562a1 1 0 001.956.238l5.382-17.793a1 1 0 01.958-.71h10.35a1 1 0 00.736-.323l15.562-16.898a1 1 0 011.454-.018l16.391 16.934a1 1 0 00.719.305h59.86a1 1 0 00.728-.315l8.67-9.228a1 1 0 011.45-.01l8.907 9.247a1 1 0 00.72.306h8.743a1 1 0 00.996-.911l7.102-79.772a1 1 0 011.995.048l4.044 98.39a1 1 0 001.961.232l4.893-17.26a1 1 0 01.962-.727h11.658a1 1 0 00.777-.37l13.53-16.7a1 1 0 011.534-.024l14.443 16.747a1 1 0 00.757.347h59.932a1 1 0 00.584-.188l13.495-9.689a1 1 0 011.19.018l12.606 9.653a1 1 0 00.608.206h6.645a1 1 0 00.998-.936l4.992-77.585a1 1 0 011.996.014l4.744 95.144a1 1 0 001.974.168l3.58-16.023a1 1 0 01.977-.782h13.828a1 1 0 00.772-.364l13.817-16.77a1 1 0 011.491-.06l16.296 16.888a1 1 0 00.72.306h60.72a1 1 0 00.687-.274l9.952-9.42a1 1 0 011.333-.038l11.247 9.496a1 1 0 00.645.236h9.675a1 1 0 00.998-.937l4.727-75.442a1 1 0 011.997.024l3.636 93.024a1 1 0 001.973.19l3.799-16.089a1 1 0 01.973-.77h16.056a1 1 0 00.786-.382l13.109-16.685a1 1 0 011.528-.053l15.169 16.79a1 1 0 00.742.33h57.217a1 1 0 00.799-.399l6.719-8.925a1 1 0 011.552-.057l7.891 9.039a1 1 0 00.753.342h7.681a1 1 0 00.99-.857L1475 1839h0"
        stroke="#00bccc"
        strokeWidth={2}
        strokeLinecap="round"
        transform="translate(-370 -1838)"
        fill="none"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default EKGLineSVG;
